import axios from '@/axios';
import { createI18n } from 'vue-i18n';

export const SUPPORTED_LOCALES = ['de', 'en', 'es', 'fr', 'it', 'pl', 'pt', 'nl'];

export function setupI18n()
{
    const i18n = createI18n({
        globalInjection: true,
        legacy:          false,
        locale:          'en',
        fallbackLocale:  'en',
    });

    setI18nLanguage(i18n, 'en');

    return i18n;
};

export function setI18nLanguage(i18n, locale)
{
    // If given locale is not supported, switch to English
    if (!SUPPORTED_LOCALES.includes(locale))
    {
        locale = 'en';
    }

    if (i18n.global)
    {
        if (i18n.mode === 'legacy')
        {
            i18n.global.locale = locale;
        }
        else
        {
            i18n.global.locale.value = locale;
        }
    }
    else
    {
        i18n.locale = locale;
    }

    axios.defaults.headers.common['Accept-Language'] = locale;

    document.querySelector('html').setAttribute('lang', locale);
};

export async function loadMessages(i18n, locale)
{
    const headers = {
        Accept:          'application/json',
        'Cache-Control': 'no-cache',
        Pragma:          'no-cache',
        Expires:         '0',
    };

    // Always load English translations (fallback)
    if (locale !== 'en')
    {
        const response_en = await axios.get('/translations/en.json', { headers });
        i18n.global.setLocaleMessage('en', response_en.data);
    }

    // Load translations for selected locale
    const response = await axios.get(`/translations/${locale}.json`, { headers });
    i18n.global.setLocaleMessage(locale, response.data);
};
